export class BannerService {
	constructor($http) {
		this.http = $http;
	}

	createBanner(banner) {
		return this.http.post('/api/banner', banner);
	}

	createBannerImage(banner) {
		return this.http.post('/api/banner/image', banner);
	}

	updateBannerImage(banner) {

		return this.http.post('/api/banner/image/update', banner);
	}

	getBanners() {
		return this.http.get('/api/banner');
	}

  getFilterBanners(params) {
    return this.http.post('/api/banner/filter', params);
  }

	updateBanner(banner) {
		return this.http.put('/api/banner/' + banner._id, banner)
	}

	removeBanner(id) {
		return this.http.delete('/api/banner/' + id)
	}
}
